(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-dimensions"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-cm-dim]').forEach(function (root) {
    const buttons = root.querySelectorAll('[data-dim-unit]');
    const values = root.querySelectorAll('[data-in][data-cm]');
    const svgW = root.querySelector('[data-dim-width]');
    const svgD = root.querySelector('[data-dim-depth]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const unit = btn.dataset.dimUnit;
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        values.forEach(function (v) {
          const val = unit === 'cm' ? v.dataset.cm : v.dataset.in;
          v.textContent = unit === 'cm' && !val.includes('kg') && !val.includes('lb') ? val + (val.includes('kg') ? '' : ' cm') : (unit === 'in' && !val.includes('lb') ? val.replace('cm', '').trim() + (val.includes('"') ? '' : '"') : val);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-fabric-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-cm-fstudio]');
  if (!root) return;

  const MAX = parseInt(root.dataset.max || '6', 10);
  const swatches = root.querySelectorAll('.cm-fstudio__swatch');
  const images = root.querySelectorAll('[data-fstudio-img]');
  const tabs = root.querySelectorAll('[data-fstudio-tab]');
  const nameEl = root.querySelector('[data-fstudio-name]');
  const metaEl = root.querySelector('[data-fstudio-meta]');

  // Selection UI (present only in product mode)
  const form = root.querySelector('[data-fstudio-form]');
  const counterEl = root.querySelector('[data-fstudio-counter]');
  const chipsEl = root.querySelector('[data-fstudio-chips]');
  const emptyEl = root.querySelector('[data-fstudio-empty]');
  const addBtn = root.querySelector('[data-fstudio-add]');
  const addLabel = root.querySelector('[data-fstudio-add-label]');
  const selected = new Map();

  // --- Preview image + caption ---
  let pinnedImg = 'default';
  let pinnedName = nameEl ? nameEl.textContent : '';
  let pinnedMeta = metaEl ? metaEl.textContent : '';

  function showImage(imgId) {
    let matched = false;
    images.forEach(function (img) {
      const on = img.dataset.fstudioImg === imgId;
      if (on) matched = true;
      img.classList.toggle('is-active', on);
    });
    if (!matched) {
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.fstudioImg === 'default');
      });
    }
  }

  function setCaption(name, meta) {
    if (nameEl && name != null) nameEl.textContent = name;
    if (metaEl && meta != null) metaEl.textContent = meta;
  }

  function preview(sw) {
    showImage(sw.dataset.fstudioImgId || 'default');
    setCaption(sw.dataset.fstudioNameVal, sw.dataset.fstudioMetaVal);
  }

  function restore() {
    showImage(pinnedImg);
    setCaption(pinnedName, pinnedMeta);
  }

  function pin(sw) {
    pinnedImg = sw.dataset.fstudioImgId || 'default';
    pinnedName = sw.dataset.fstudioNameVal;
    pinnedMeta = sw.dataset.fstudioMetaVal;
    restore();
  }

  // --- Selection (product mode) ---
  function updateLabel() {
    const n = selected.size;
    if (counterEl) counterEl.textContent = n;
    if (addBtn) addBtn.disabled = n === 0;
    if (addLabel) {
      addLabel.textContent = n === 1 ? 'Add 1 swatch to cart' : 'Add ' + n + ' swatches to cart';
    }
  }

  function renderChips() {
    if (!chipsEl) return;
    chipsEl.querySelectorAll('.cm-fstudio__chip').forEach(function (n) { n.remove(); });
    if (selected.size === 0) {
      if (emptyEl) emptyEl.style.display = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    selected.forEach(function (color, id) {
      const li = document.createElement('li');
      li.className = 'cm-fstudio__chip';
      const text = document.createElement('span');
      text.textContent = color;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-fstudio__chip-remove';
      btn.setAttribute('aria-label', 'Remove ' + color);
      btn.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M6 18L18 6"/></svg>';
      btn.addEventListener('click', function () {
        const sw = root.querySelector('.cm-fstudio__swatch[data-variant-id="' + id + '"]');
        if (sw) toggleSelect(sw);
      });
      li.appendChild(text);
      li.appendChild(btn);
      chipsEl.appendChild(li);
    });
  }

  function refreshLimit() {
    const atMax = selected.size >= MAX;
    swatches.forEach(function (s) {
      const lock = atMax && !selected.has(s.dataset.variantId);
      s.classList.toggle('is-disabled', lock);
      const addBtn = s.querySelector('[data-fstudio-add-btn]');
      if (addBtn) addBtn.disabled = lock;
    });
  }

  function toggleSelect(el) {
    const id = el.dataset.variantId;
    if (!id) return;
    const addBtn = el.querySelector('[data-fstudio-add-btn]');
    if (selected.has(id)) {
      selected.delete(id);
      el.classList.remove('is-selected');
      if (addBtn) addBtn.setAttribute('aria-pressed', 'false');
    } else {
      if (selected.size >= MAX) return;
      selected.set(id, el.dataset.color);
      el.classList.add('is-selected');
      if (addBtn) addBtn.setAttribute('aria-pressed', 'true');
    }
    updateLabel();
    renderChips();
    refreshLimit();
  }

  // --- Wire swatches ---
  swatches.forEach(function (sw) {
    sw.addEventListener('mouseenter', function () { preview(sw); });
    sw.addEventListener('mouseleave', restore);
    // Block-mode fallback: the whole swatch is the preview trigger.
    if (!sw.querySelector('[data-fstudio-add-btn]')) {
      sw.addEventListener('click', function (e) { e.preventDefault(); pin(sw); });
      sw.addEventListener('focus', function () { preview(sw); });
      sw.addEventListener('blur', restore);
    }
  });

  // Preview only — clicking the circle or name never adds to the order.
  root.querySelectorAll('[data-fstudio-preview]').forEach(function (btn) {
    const sw = btn.closest('.cm-fstudio__swatch');
    if (!sw) return;
    btn.addEventListener('click', function () { pin(sw); });
    btn.addEventListener('focus', function () { preview(sw); });
    btn.addEventListener('blur', restore);
  });

  // Add / remove — the only control that changes the order.
  root.querySelectorAll('[data-fstudio-add-btn]').forEach(function (btn) {
    const sw = btn.closest('.cm-fstudio__swatch');
    if (!sw) return;
    btn.addEventListener('click', function () {
      if (sw.classList.contains('is-disabled') && !selected.has(sw.dataset.variantId)) return;
      pin(sw);
      toggleSelect(sw);
    });
  });

  // --- Tabs (tier filter) ---
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const filter = tab.dataset.fstudioTab;
      tabs.forEach(function (t) {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      swatches.forEach(function (sw) {
        sw.classList.toggle('is-hidden', filter !== 'all' && sw.dataset.fstudioCategory !== filter);
      });
    });
  });

  // --- Add to cart ---
  if (form && addBtn) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (selected.size === 0) return;
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';
      const items = Array.from(selected.keys()).map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        window.location.href = '/cart';
      } catch (err) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = 'Try again';
      }
    });
  }

  updateLabel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-family-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-fhero]').forEach(function (section) {
    const video = section.querySelector('.cm-fhero__video');
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.matches) { video.pause(); return; }
    const tryPlay = function () {
      const p = video.play();
      if (p !== undefined) {
        p.catch(function () {
          const retry = function () {
            video.play().catch(function () {});
            ['touchstart', 'scroll', 'click'].forEach(function (e) { document.removeEventListener(e, retry); });
          };
          ['touchstart', 'scroll', 'click'].forEach(function (e) {
            document.addEventListener(e, retry, { passive: true, once: true });
          });
        });
      }
    };
    if (video.readyState >= 2) tryPlay();
    else {
      video.addEventListener('loadedmetadata', tryPlay, { once: true });
      video.addEventListener('canplay', tryPlay, { once: true });
    }
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) video.play().catch(function () {});
          else video.pause();
        });
      }, { threshold: 0.1 });
      io.observe(video);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-pdp-hero-image"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pdp-hero]').forEach(function (section) {
    const video = section.querySelector('.cm-pdp-hero__video');
    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.matches) {
      video.pause();
      return;
    }

    const tryPlay = function () {
      const p = video.play();
      if (p !== undefined) {
        p.catch(function () {
          const retry = function () {
            video.play().catch(function () {});
            ['touchstart', 'scroll', 'click'].forEach(function (e) {
              document.removeEventListener(e, retry);
            });
          };
          ['touchstart', 'scroll', 'click'].forEach(function (e) {
            document.addEventListener(e, retry, { passive: true, once: true });
          });
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadedmetadata', tryPlay, { once: true });
      video.addEventListener('canplay', tryPlay, { once: true });
    }

    /* Pause out of view */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.1 });
      io.observe(video);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-sofa-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  const FABRIC_CATALOG = {
    'cassis': [
      { color: 'Nature', hex: '#B8B5AE' },
      { color: 'Ivory', hex: '#EFE8DC' },
      { color: 'Fossil', hex: '#B8A99A' }
    ],
    'belgian-linen': [
      { color: 'Flax', hex: '#D2C9B4' },
      { color: 'Ivory', hex: '#F0E9DA' },
      { color: 'Mushroom', hex: '#A89B88' },
      { color: 'Olive', hex: '#7A7A5A' }
    ],
    'velvet': [
      { color: 'Coral', hex: '#C97566' }, { color: 'Amber', hex: '#B8873F' },
      { color: 'Plum', hex: '#6B4A5C' }, { color: 'Flannel', hex: '#3A4856' },
      { color: 'Lagoon', hex: '#3E6B6E' }, { color: 'Olive', hex: '#6B7248' },
      { color: 'Camel', hex: '#B5936B' }, { color: 'Fossil', hex: '#A8A099' },
      { color: 'Beige', hex: '#D6C8B3' }, { color: 'Cream', hex: '#EDE4D0' },
      { color: 'Snow', hex: '#F5F0E8' }, { color: 'Ivory', hex: '#E8DFC8' },
      { color: 'Elephant', hex: '#8B8580' }, { color: 'Steel', hex: '#4F4E4D' },
      { color: 'Smoke', hex: '#3A3735' }
    ]
  };

  const TIER_LABEL = { 'cassis': 'Cassis', 'belgian-linen': 'Belgian Linen', 'velvet': 'Velvet' };
  const TIER_ETA = { 'cassis': 'Ships in 3–4 weeks', 'belgian-linen': 'Ships in 6–8 weeks', 'velvet': 'Ships in 8–10 weeks' };

  /* Geometry is expressed in real inches and scaled to SVG units, so a 73"
     one-arm sits correctly against a 41" armless instead of being forced onto
     a square grid. UNIT is one 41" module, kept at 80 units for the existing art. */
  const UNIT = 80;
  const PX_PER_IN = UNIT / 41;
  const SNAP = UNIT;          // coarse fallback grid, one 41" module
  const EDGE_SNAP = 40;       // how close an edge must be to click together (half a module)
  const CANVAS_W = 800;
  const CANVAS_H = 600;
  const FLOOR_H = 40;         // reserved strip for the scale bar

  const MODULE_SPECS = {
    'armless': { w: 41, d: 41, label: 'ARMLESS' },
    'corner':  { w: 41, d: 41, label: 'CORNER' },
    'ottoman': { w: 41, d: 41, label: 'OTTOMAN' },
    'one-arm': { w: 73, d: 41, label: 'ONE ARM' },
    'chaise':  { w: 73, d: 41, label: 'CHAISE' }
  };
  const MODULE_TYPES = Object.keys(MODULE_SPECS);

  /* Footprint in SVG units, accounting for rotation. */
  function sizeOf(type, rotation) {
    const spec = MODULE_SPECS[type] || MODULE_SPECS.armless;
    const turned = (rotation % 180) !== 0;
    return {
      w: (turned ? spec.d : spec.w) * PX_PER_IN,
      h: (turned ? spec.w : spec.d) * PX_PER_IN
    };
  }

  function rectOf(m) {
    const s = sizeOf(m.type, m.rotation);
    return { x: m.x, y: m.y, w: s.w, h: s.h };
  }

  function overlaps(a, b) {
    const tol = 0.5; // shared edges are not an overlap
    return a.x + a.w - tol > b.x && b.x + b.w - tol > a.x &&
           a.y + a.h - tol > b.y && b.y + b.h - tol > a.y;
  }

  let uid = 0;

  document.querySelectorAll('[data-cm-builder]').forEach(function (root) {
    const dataEl = root.querySelector('[data-builder-data]');
    if (!dataEl) return;
    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) { return; }

    const svg = root.querySelector('[data-canvas]');
    const modulesLayer = root.querySelector('[data-modules]');
    const emptyState = root.querySelector('[data-empty-state]');
    const swatchesEl = root.querySelector('[data-fabric-swatches]');
    const subtotalEl = root.querySelector('[data-subtotal]');
    const totalModulesEl = root.querySelector('[data-total-modules]');
    const deliveryEl = root.querySelector('[data-delivery]');
    const footprintEl = root.querySelector('[data-footprint]');
    const atcBtn = root.querySelector('[data-atc]');
    const selectedFabricNameEl = root.querySelector('[data-selected-fabric-name]');
    const hint = root.querySelector('[data-canvas-hint]');

    const state = {
      tier: 'cassis',
      fabricColor: 'Nature',
      modules: [],
      selectedId: null
    };

    /* ======== Utility: SVG point from pointer event ======== */
    function svgPoint(evt) {
      const pt = svg.createSVGPoint();
      pt.x = evt.clientX;
      pt.y = evt.clientY;
      const ctm = svg.getScreenCTM();
      if (!ctm) return { x: 0, y: 0 };
      const out = pt.matrixTransform(ctm.inverse());
      return { x: out.x, y: out.y };
    }

    function clampToCanvas(x, y, size) {
      return {
        x: Math.max(0, Math.min(x, CANVAS_W - size.w)),
        y: Math.max(0, Math.min(y, CANVAS_H - FLOOR_H - size.h))
      };
    }

    function isOccupied(x, y, size, excludeId) {
      const box = { x: x, y: y, w: size.w, h: size.h };
      return state.modules.some(function (m) {
        if (excludeId && m.id === excludeId) return false;
        return overlaps(box, rectOf(m));
      });
    }

    /* Candidate positions that butt the moving module flush against an existing
       one. Works for any width, which is what lets a 73" piece meet a 41" piece. */
    function edgeCandidates(size, excludeId) {
      const out = [];
      state.modules.forEach(function (m) {
        if (excludeId && m.id === excludeId) return;
        const r = rectOf(m);
        // left / right of the neighbour, aligned on each shared horizontal edge
        [r.y, r.y + r.h - size.h].forEach(function (ny) {
          out.push({ x: r.x - size.w, y: ny });
          out.push({ x: r.x + r.w, y: ny });
        });
        // above / below, aligned on each shared vertical edge
        [r.x, r.x + r.w - size.w].forEach(function (nx) {
          out.push({ x: nx, y: r.y - size.h });
          out.push({ x: nx, y: r.y + r.h });
        });
      });
      return out;
    }

    /* Resolve a desired top-left position to a legal one: snap flush to a
       neighbour when close enough, else fall back to the 41" grid, else search
       outward for the nearest free spot. */
    function resolvePosition(x, y, size, excludeId) {
      let best = null;
      let bestDist = Infinity;

      edgeCandidates(size, excludeId).forEach(function (c) {
        const dist = Math.hypot(c.x - x, c.y - y);
        if (dist > EDGE_SNAP || dist >= bestDist) return;
        const cl = clampToCanvas(c.x, c.y, size);
        if (cl.x !== c.x || cl.y !== c.y) return;
        if (isOccupied(c.x, c.y, size, excludeId)) return;
        best = c;
        bestDist = dist;
      });
      if (best) return best;

      const gx = Math.round(x / SNAP) * SNAP;
      const gy = Math.round(y / SNAP) * SNAP;
      const grid = clampToCanvas(gx, gy, size);
      if (!isOccupied(grid.x, grid.y, size, excludeId)) return grid;

      const MAX_R = 12;
      for (let r = 1; r <= MAX_R; r++) {
        for (let dy = -r; dy <= r; dy++) {
          for (let dx = -r; dx <= r; dx++) {
            if (Math.abs(dx) !== r && Math.abs(dy) !== r) continue;
            const cx = grid.x + dx * SNAP;
            const cy = grid.y + dy * SNAP;
            const cl = clampToCanvas(cx, cy, size);
            if (cl.x !== cx || cl.y !== cy) continue;
            if (!isOccupied(cx, cy, size, excludeId)) return { x: cx, y: cy };
          }
        }
      }
      return null;
    }

    /* ======== Fabric tiers + swatches ======== */
    function renderSwatches() {
      if (!swatchesEl) return;
      const fabrics = FABRIC_CATALOG[state.tier] || [];
      swatchesEl.innerHTML = fabrics.map(function (f) {
        return (
          '<button type="button" class="cm-builder__swatch' +
          (f.color === state.fabricColor ? ' is-active' : '') +
          '" data-fabric="' + f.color + '" title="' + f.color + '">' +
          '<span class="cm-builder__swatch-circle" style="background:' + f.hex + '"></span>' +
          '<span class="cm-builder__swatch-label">' + f.color + '</span>' +
          '</button>'
        );
      }).join('');

      swatchesEl.querySelectorAll('[data-fabric]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.fabricColor = btn.dataset.fabric;
          renderSwatches();
          refresh();
        });
      });
    }

    root.querySelectorAll('[data-fabric-tier]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.tier = tab.dataset.fabricTier;
        state.fabricColor = FABRIC_CATALOG[state.tier][0].color;
        root.querySelectorAll('[data-fabric-tier]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        renderSwatches();
        refresh();
      });
    });

    /* ======== Variant + price lookup ======== */
    function getVariant(type) {
      const m = data.modules[type];
      if (!m) return null;
      const opt = TIER_LABEL[state.tier] + ' - ' + state.fabricColor;
      return m.variants.find(function (v) { return v.option1 === opt; }) || null;
    }

    function getPrice(type) {
      const v = getVariant(type);
      return v ? v.price : 0;
    }

    /* ======== Add / remove / update modules ======== */
    function addModule(type, x, y) {
      if (!MODULE_SPECS[type] || !data.modules[type]) return;
      const size = sizeOf(type, 0);
      const spot = resolvePosition(x - size.w / 2, y - size.h / 2, size, null);
      if (!spot) return; // canvas full, unlikely
      uid += 1;
      const m = {
        id: 'm' + uid,
        type: type,
        x: spot.x,
        y: spot.y,
        rotation: 0
      };
      state.modules.push(m);
      state.selectedId = m.id;
      refresh();
    }

    function removeModule(id) {
      state.modules = state.modules.filter(function (m) { return m.id !== id; });
      if (state.selectedId === id) state.selectedId = null;
      refresh();
    }

    function rotateModule(id) {
      const m = state.modules.find(function (x) { return x.id === id; });
      if (!m) return;
      const next = (m.rotation + 90) % 360;
      const size = sizeOf(m.type, next);
      // Rotate about the module's centre so a 73" piece pivots in place.
      const before = sizeOf(m.type, m.rotation);
      const cx = m.x + before.w / 2;
      const cy = m.y + before.h / 2;
      const spot = resolvePosition(cx - size.w / 2, cy - size.h / 2, size, id);
      if (!spot) return; // no room to turn, leave it as it was
      m.rotation = next;
      m.x = spot.x;
      m.y = spot.y;
      refresh();
    }

    function moveModule(id, x, y) {
      const m = state.modules.find(function (mod) { return mod.id === id; });
      if (!m) return;
      const size = sizeOf(m.type, m.rotation);
      const target = clampToCanvas(x - size.w / 2, y - size.h / 2, size);

      // Snap flush to a neighbouring edge when close, otherwise follow the
      // cursor freely. Positions that would overlap are simply not taken.
      let next = null;
      let bestDist = Infinity;
      edgeCandidates(size, id).forEach(function (c) {
        const dist = Math.hypot(c.x - target.x, c.y - target.y);
        if (dist > EDGE_SNAP || dist >= bestDist) return;
        const cl = clampToCanvas(c.x, c.y, size);
        if (cl.x !== c.x || cl.y !== c.y) return;
        if (isOccupied(c.x, c.y, size, id)) return;
        next = c;
        bestDist = dist;
      });
      if (!next && !isOccupied(target.x, target.y, size, id)) next = target;
      if (!next) return;

      m.x = next.x;
      m.y = next.y;
      refresh();
    }

    /* ======== Palette: click OR drag ======== */
    root.querySelectorAll('[data-palette]').forEach(function (item) {
      const type = item.dataset.palette;

      // Click: add at center (or offset from existing modules)
      item.addEventListener('click', function () {
        let cx = CANVAS_W / 2;
        let cy = CANVAS_H / 2;
        // Offset a bit if there are already modules so they don't stack
        const offset = state.modules.length * 8;
        cx += offset; cy += offset;
        addModule(type, cx, cy);
      });

      // Drag start
      item.addEventListener('dragstart', function (e) {
        item.classList.add('is-dragging');
        e.dataTransfer.effectAllowed = 'copy';
        e.dataTransfer.setData('text/cm-module', type);
      });
      item.addEventListener('dragend', function () {
        item.classList.remove('is-dragging');
      });

      // Keyboard: Enter or Space adds
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });

    // Canvas drop target
    svg.addEventListener('dragover', function (e) {
      if (!e.dataTransfer.types.includes('text/cm-module')) return;
      e.preventDefault();
      svg.classList.add('is-drop-target');
    });
    svg.addEventListener('dragleave', function () {
      svg.classList.remove('is-drop-target');
    });
    svg.addEventListener('drop', function (e) {
      const type = e.dataTransfer.getData('text/cm-module');
      if (!type) return;
      e.preventDefault();
      svg.classList.remove('is-drop-target');
      const pt = svgPoint(e);
      addModule(type, pt.x, pt.y);
    });

    /* ======== Canvas: drag + select ======== */
    let activeDrag = null;

    svg.addEventListener('pointerdown', function (e) {
      const target = e.target.closest('.cm-mod');
      if (!target) {
        state.selectedId = null;
        refresh();
        return;
      }
      const id = target.dataset.id;
      state.selectedId = id;

      activeDrag = {
        id: id,
        startX: 0,
        startY: 0,
        moved: false,
        pointerId: e.pointerId
      };
      try { svg.setPointerCapture(e.pointerId); } catch (err) {}
      refresh();
    });

    svg.addEventListener('pointermove', function (e) {
      if (!activeDrag) return;
      const pt = svgPoint(e);
      activeDrag.moved = true;
      moveModule(activeDrag.id, pt.x, pt.y);
    });

    function endDrag(e) {
      if (!activeDrag) return;
      try { svg.releasePointerCapture(activeDrag.pointerId); } catch (err) {}
      activeDrag = null;
    }
    svg.addEventListener('pointerup', endDrag);
    svg.addEventListener('pointercancel', endDrag);

    /* ======== Presets ======== */
    root.querySelectorAll('[data-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const p = btn.dataset.preset;
        state.modules = [];
        state.selectedId = null;

        const cx = CANVAS_W / 2;
        const cy = CANVAS_H / 2;
        const presets = {
          'sofa': [
            { type: 'armless', dx: -1, dy: 0 }, { type: 'armless', dx: 0, dy: 0 }, { type: 'armless', dx: 1, dy: 0 }
          ],
          'l-left': [
            { type: 'armless', dx: -1, dy: -1, rot: 90 },
            { type: 'corner',  dx: -1, dy: 0 },
            { type: 'armless', dx: 0,  dy: 0 },
            { type: 'armless', dx: 1,  dy: 0 },
            { type: 'armless', dx: 2,  dy: 0 }
          ],
          'l-right': [
            { type: 'armless', dx: -2, dy: 0 },
            { type: 'armless', dx: -1, dy: 0 },
            { type: 'armless', dx: 0,  dy: 0 },
            { type: 'corner',  dx: 1,  dy: 0, rot: 90 },
            { type: 'armless', dx: 1,  dy: -1, rot: 90 }
          ],
          'u': [
            { type: 'armless', dx: -2, dy: -1, rot: 90 },
            { type: 'corner',  dx: -2, dy: 0 },
            { type: 'armless', dx: -1, dy: 0 },
            { type: 'armless', dx: 0,  dy: 0 },
            { type: 'armless', dx: 1,  dy: 0 },
            { type: 'corner',  dx: 2,  dy: 0, rot: 90 },
            { type: 'armless', dx: 2,  dy: -1, rot: 90 }
          ]
        };
        // Presets are laid out on the 41" module grid and mirror the four
        // ready-made Nimbus products, so a preset build matches a real SKU.
        const layout = presets[p] || [];
        layout.forEach(function (pc) {
          if (!data.modules[pc.type]) return;
          uid += 1;
          const rot = pc.rot || 0;
          const size = sizeOf(pc.type, rot);
          const x = cx + pc.dx * UNIT - UNIT / 2;
          const y = cy + pc.dy * UNIT - UNIT / 2;
          const clamped = clampToCanvas(x, y, size);
          state.modules.push({
            id: 'm' + uid,
            type: pc.type,
            x: clamped.x,
            y: clamped.y,
            rotation: rot
          });
        });
        refresh();
      });
    });

    root.querySelectorAll('[data-action="clear"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.modules = [];
        state.selectedId = null;
        refresh();
      });
    });

    /* ======== Keyboard ======== */
    document.addEventListener('keydown', function (e) {
      if (!state.selectedId) return;
      // only respond if user is interacting with the builder (not typing in inputs)
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === 'r' || e.key === 'R') {
        rotateModule(state.selectedId);
      } else if (e.key === 'Backspace' || e.key === 'Delete') {
        e.preventDefault();
        removeModule(state.selectedId);
      } else if (e.key === 'Escape') {
        state.selectedId = null;
        refresh();
      }
    });

    /* ======== Render ======== */
    /* Drawn unrotated at the type's natural size, then turned about its own
       centre, so the artwork and the footprint always agree. */
    function renderModule(m) {
      const isSelected = state.selectedId === m.id;
      const cls = 'cm-mod' + (isSelected ? ' is-selected' : '');
      const spec = MODULE_SPECS[m.type] || MODULE_SPECS.armless;
      const w = spec.w * PX_PER_IN;
      const h = spec.d * PX_PER_IN;
      const placed = sizeOf(m.type, m.rotation);
      // translate to where the unrotated art must sit for the rotation to land
      // on the module's real top-left corner
      const ox = m.x + (placed.w - w) / 2;
      const oy = m.y + (placed.h - h) / 2;
      const transform =
        'translate(' + ox + ',' + oy + ') rotate(' + m.rotation + ',' + (w / 2) + ',' + (h / 2) + ')';

      const label =
        '<text x="' + (w / 2) + '" y="' + (h / 2 + 3) + '" text-anchor="middle" ' +
        'font-family="Jost, sans-serif" font-size="8" fill="#78716C" letter-spacing="1">' +
        spec.label + '</text>';

      let shape = '';
      if (m.type === 'ottoman') {
        shape =
          '<rect class="cm-mod__shape" x="4" y="18" width="' + (w - 8) + '" height="' + (h - 36) + '" fill="#EDE8DF" stroke="#1C1917" stroke-width="1"/>';
      } else if (m.type === 'corner') {
        shape =
          '<rect class="cm-mod__shape" x="2" y="2" width="' + (w - 4) + '" height="' + (h - 4) + '" fill="#EDE8DF" stroke="#1C1917" stroke-width="1"/>' +
          '<path d="M2 14 L' + (w - 14) + ' 14 L' + (w - 14) + ' ' + h + '" stroke="#1C1917" stroke-width="0.8" opacity="0.4" fill="none"/>';
      } else if (m.type === 'one-arm') {
        const arm = 14;
        shape =
          '<rect class="cm-mod__shape" x="2" y="2" width="' + (w - 4) + '" height="' + (h - 4) + '" fill="#EDE8DF" stroke="#1C1917" stroke-width="1"/>' +
          '<rect x="2" y="2" width="' + arm + '" height="' + (h - 4) + '" fill="#DED7CA" stroke="#1C1917" stroke-width="1"/>' +
          '<path d="M' + (2 + arm) + ' 14 L' + (w - 2) + ' 14" stroke="#1C1917" stroke-width="0.8" opacity="0.4"/>';
      } else if (m.type === 'chaise') {
        shape =
          '<rect class="cm-mod__shape" x="2" y="2" width="' + (w - 4) + '" height="' + (h - 4) + '" fill="#EDE8DF" stroke="#1C1917" stroke-width="1"/>' +
          '<path d="M2 14 L' + (w * 0.62) + ' 14" stroke="#1C1917" stroke-width="0.8" opacity="0.4"/>' +
          '<path d="M' + (w * 0.62) + ' 2 L' + (w * 0.62) + ' ' + (h - 2) + '" stroke="#1C1917" stroke-width="0.8" opacity="0.4"/>';
      } else {
        shape =
          '<rect class="cm-mod__shape" x="2" y="2" width="' + (w - 4) + '" height="' + (h - 4) + '" fill="#EDE8DF" stroke="#1C1917" stroke-width="1"/>' +
          '<path d="M2 14 L' + (w - 2) + ' 14" stroke="#1C1917" stroke-width="0.8" opacity="0.4"/>';
      }

      return (
        '<g class="' + cls + '" data-id="' + m.id + '" transform="' + transform + '">' +
        '  <rect class="cm-mod__halo" x="-4" y="-4" width="' + (w + 8) + '" height="' + (h + 8) + '"/>' +
        shape + label +
        '</g>'
      );
    }

    /* Overall footprint of the current build, in inches. */
    function footprintLabel() {
      if (state.modules.length === 0) return '—';
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      state.modules.forEach(function (m) {
        const r = rectOf(m);
        minX = Math.min(minX, r.x);
        minY = Math.min(minY, r.y);
        maxX = Math.max(maxX, r.x + r.w);
        maxY = Math.max(maxY, r.y + r.h);
      });
      const w = Math.round((maxX - minX) / PX_PER_IN);
      const d = Math.round((maxY - minY) / PX_PER_IN);
      return w + '″ W × ' + d + '″ D';
    }

    function refresh() {
      // render SVG modules
      modulesLayer.innerHTML = state.modules.map(renderModule).join('');
      if (emptyState) emptyState.style.display = state.modules.length === 0 ? '' : 'none';

      // update hint
      if (hint) hint.classList.toggle('is-visible', state.modules.length > 0);

      // update module prices in palette
      MODULE_TYPES.forEach(function (k) {
        const el = root.querySelector('[data-module-price="' + k + '"]');
        if (el) el.textContent = formatMoney(getPrice(k));
      });

      // totals
      const totalCents = state.modules.reduce(function (sum, m) {
        return sum + getPrice(m.type);
      }, 0);

      if (subtotalEl) subtotalEl.textContent = formatMoney(totalCents);
      if (totalModulesEl) {
        const n = state.modules.length;
        totalModulesEl.textContent = n === 1 ? '1 module' : n + ' modules';
      }
      if (footprintEl) footprintEl.textContent = footprintLabel();
      if (deliveryEl) deliveryEl.textContent = state.modules.length > 0 ? TIER_ETA[state.tier] : 'Select fabric';
      if (selectedFabricNameEl) selectedFabricNameEl.textContent = TIER_LABEL[state.tier] + ' — ' + state.fabricColor;
      if (atcBtn) atcBtn.disabled = state.modules.length === 0;
    }

    /* ======== Add to cart ======== */
    if (atcBtn) {
      atcBtn.addEventListener('click', async function () {
        if (state.modules.length === 0) return;
        atcBtn.disabled = true;
        const textEl = atcBtn.querySelector('.cm-builder__atc-text');
        const original = textEl.textContent;
        textEl.textContent = 'Adding...';

        const buildId = 'nimbus-' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
        const fabric = TIER_LABEL[state.tier] + ' — ' + state.fabricColor;

        // Group modules by type
        const byType = {};
        state.modules.forEach(function (m) {
          byType[m.type] = (byType[m.type] || 0) + 1;
        });

        const items = [];
        Object.keys(byType).forEach(function (type) {
          const v = getVariant(type);
          if (!v) return;
          items.push({
            id: v.id,
            quantity: byType[type],
            properties: {
              '_build_id': buildId,
              '_build_family': 'Nimbus',
              'Configuration': 'Custom Build',
              'Fabric': fabric
            }
          });
        });

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!response.ok) {
            const errorText = await response.text();
            console.error('[builder] cart/add failed', response.status, errorText);
            throw new Error('Cart add failed: ' + response.status);
          }

          textEl.textContent = 'Added!';

          // CM cart drawer auto-opens via fetch interceptor, but call directly too
          if (window.cmCart && typeof window.cmCart.open === 'function') {
            window.cmCart.open();
          } else {
            // Fallback to Horizon's cart drawer if present
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }

          setTimeout(function () {
            textEl.textContent = original;
            atcBtn.disabled = false;
          }, 1500);
        } catch (err) {
          console.error('[builder] ATC error', err);
          textEl.textContent = 'Error — try again';
          if (window.cmCart && typeof window.cmCart.toast === 'function') {
            window.cmCart.toast('Could not add to cart. Please try again.', true);
          }
          setTimeout(function () {
            textEl.textContent = original;
            atcBtn.disabled = false;
          }, 2000);
        }
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
    }

    // Init
    renderSwatches();
    refresh();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-sticky-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-cm-stickybuy]').forEach(function (bar) {
    const revealAfter = parseInt(bar.dataset.revealAfter || '600', 10);
    const form = bar.querySelector('[data-cm-stickybuy-form]');
    const btn = bar.querySelector('[data-cm-stickybuy-btn]');
    const variantInput = bar.querySelector('[data-cm-stickybuy-id]');
    const priceEl = bar.querySelector('[data-cm-stickybuy-price]');
    const monthlyEl = bar.querySelector('[data-cm-stickybuy-monthly]');
    const configEl = bar.querySelector('[data-cm-stickybuy-config]');

    /* Reveal on scroll */
    function onScroll() {
      if (window.scrollY > revealAfter) {
        if (!bar.classList.contains('is-visible')) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
          document.body.classList.add('cm-stickybuy-active');
        }
      } else {
        if (bar.classList.contains('is-visible')) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('cm-stickybuy-active');
        }
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Keep sticky bar in sync with main product form variant selection */
    document.addEventListener('variant:change', function (e) {
      const v = e.detail && e.detail.variant;
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (priceEl && v.price) {
        priceEl.textContent = formatMoney(v.price);
      }
      if (monthlyEl && v.price) {
        const months = parseInt(bar.getAttribute('data-months') || '12', 10);
        monthlyEl.textContent = formatMoney(Math.round(v.price / months));
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.querySelector('.cm-stickybuy__btn-label').textContent = v.available ? btn.dataset.label || 'Add to Cart' : 'Sold Out';
      }
    });

    /* AJAX the form — hand off to cart drawer */
    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (!btn || btn.disabled) return;
        const label = btn.querySelector('.cm-stickybuy__btn-label');
        const origLabel = label ? label.textContent : '';
        btn.disabled = true;
        if (label) label.textContent = 'Adding...';
        try {
          const variantId = variantInput ? variantInput.value : null;
          if (!variantId) throw new Error('No variant selected');
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!response.ok) throw new Error('Add to cart failed');
          if (label) label.textContent = 'Added!';
          // cart drawer auto-opens via fetch interceptor
          if (window.cmCart && typeof window.cmCart.open === 'function') {
            window.cmCart.open();
          }
          setTimeout(function () {
            if (label) label.textContent = origLabel;
            btn.disabled = false;
          }, 1500);
        } catch (err) {
          if (label) label.textContent = 'Error — try again';
          if (window.cmCart && typeof window.cmCart.toast === 'function') {
            window.cmCart.toast('Could not add to cart', true);
          }
          setTimeout(function () {
            if (label) label.textContent = origLabel;
            btn.disabled = false;
          }, 2000);
        }
      });
    }

    /* Listen to configurator changes (if present) */
    document.addEventListener('cm-configurator:change', function (e) {
      const d = e.detail || {};
      if (configEl && (d.layout || d.fabric)) {
        configEl.textContent = [d.layout, d.fabric].filter(Boolean).join(' · ');
      }
    });

    function formatMoney(cents) {
      try {
        const symbol = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
        const amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        return (symbol ? symbol + ' ' : '$') + amount;
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-swatch-shop"] && !Shopify.designMode) return;
  try {
    
(function() {
  const root = document.querySelector('[data-cm-sw]');
  if (!root) return;

  const MAX = parseInt(root.dataset.max || '6', 10);
  const form = root.querySelector('[data-cm-sw-form]');
  const swatches = root.querySelectorAll('.cm-sw__swatch');
  const tabs = root.querySelectorAll('.cm-sw__tab');
  const counterEl = root.querySelector('[data-counter]');
  const chipsEl = root.querySelector('[data-chips]');
  const emptyEl = root.querySelector('[data-empty]');
  const addBtn = root.querySelector('[data-add]');
  const addLabel = root.querySelector('[data-add-label]');
  const errorEl = root.querySelector('[data-error]');
  const selected = new Map();

  function updateLabel() {
    const n = selected.size;
    counterEl.textContent = n;
    addBtn.disabled = n === 0;
    if (n === 0) {
      addLabel.textContent = `Add 0 swatches to cart`;
    } else if (n === 1) {
      addLabel.textContent = `Add 1 swatch to cart`;
    } else {
      addLabel.textContent = `Add ${n} swatches to cart`;
    }
  }

  function renderChips() {
    chipsEl.querySelectorAll('.cm-sw__chip').forEach(n => n.remove());
    if (selected.size === 0) {
      if (emptyEl) emptyEl.style.display = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    selected.forEach((title, id) => {
      const li = document.createElement('li');
      li.className = 'cm-sw__chip';
      const text = document.createElement('span');
      text.textContent = title;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-sw__chip-remove';
      btn.setAttribute('aria-label', `Remove ${title}`);
      btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M6 18L18 6"/></svg>';
      btn.addEventListener('click', function() {
        const sw = root.querySelector(`.cm-sw__swatch[data-variant-id="${id}"]`);
        if (sw) toggleSwatch(sw);
      });
      li.appendChild(text);
      li.appendChild(btn);
      chipsEl.appendChild(li);
    });
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function hideError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function refreshLimitState() {
    const atMax = selected.size >= MAX;
    swatches.forEach(s => {
      const id = s.dataset.variantId;
      const isSelected = selected.has(id);
      s.classList.toggle('is-disabled', atMax && !isSelected);
    });
  }

  function toggleSwatch(el) {
    const id = el.dataset.variantId;
    if (selected.has(id)) {
      selected.delete(id);
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    } else {
      if (selected.size >= MAX) return;
      const color = el.dataset.color;
      selected.set(id, color);
      el.classList.add('is-selected');
      el.setAttribute('aria-pressed', 'true');
    }
    updateLabel();
    renderChips();
    refreshLimitState();
  }

  swatches.forEach(sw => {
    sw.addEventListener('click', function(e) {
      e.preventDefault();
      if (sw.classList.contains('is-disabled') && !selected.has(sw.dataset.variantId)) return;
      toggleSwatch(sw);
    });
  });

  // Pre-select the swatch indicated by ?variant= in the URL (e.g. from a
  // "Order this swatch" link elsewhere on the site).
  const urlVariant = new URLSearchParams(window.location.search).get('variant');
  if (urlVariant) {
    const target = root.querySelector(`.cm-sw__swatch[data-variant-id="${urlVariant}"]`);
    if (target) {
      toggleSwatch(target);
      // Switch the visible tier tab so the user can see what was selected
      const tier = target.dataset.tier;
      if (tier) {
        const tabForTier = root.querySelector(`.cm-sw__tab[data-tab="${tier}"]`);
        if (tabForTier) tabForTier.click();
      }
      // Scroll the swatch into view (smooth, allows the tab switch to settle)
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 50);
    }
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const filter = tab.dataset.tab;
      tabs.forEach(t => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      swatches.forEach(s => {
        s.classList.toggle('is-hidden', filter !== 'all' && s.dataset.tier !== filter);
      });
    });
  });

  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    if (selected.size === 0) return;
    addBtn.disabled = true;
    addLabel.textContent = 'Adding…';
    hideError();
    const items = Array.from(selected.keys()).map(id => ({ id: parseInt(id, 10), quantity: 1 }));
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        // Shopify returns the reason in the JSON body (e.g. "already sold out").
        // Surface it instead of failing silently.
        let reason = '';
        try {
          const body = await res.json();
          reason = body.description || body.message || '';
        } catch (parseErr) {
          reason = '';
        }
        throw new Error(reason || `Add to cart failed (${res.status})`);
      }
      window.location.href = '/cart';
    } catch (err) {
      addBtn.disabled = false;
      addLabel.textContent = 'Try again';
      showError(err.message);
      console.error('[cm-swatch-shop]', err);
    }
  });

  updateLabel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-video-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-vhero]').forEach(function (section) {
    const video = section.querySelector('.cm-vhero__video');
    if (!video) return;

    /* Ensure required attributes are set (defensive in case the filter missed any) */
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    /* Reduced motion: do not autoplay */
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.matches) {
      video.pause();
      return;
    }

    /* Force autoplay — iOS sometimes blocks autoplay until the video is ready.
       Try play() on loadedmetadata and on first user scroll/touch as a fallback. */
    const tryPlay = function () {
      const promise = video.play();
      if (promise !== undefined) {
        promise.catch(function () {
          /* Autoplay blocked — retry on first interaction */
          const retry = function () {
            video.play().catch(function () {});
            document.removeEventListener('touchstart', retry);
            document.removeEventListener('scroll', retry);
            document.removeEventListener('click', retry);
          };
          document.addEventListener('touchstart', retry, { passive: true, once: true });
          document.addEventListener('scroll', retry, { passive: true, once: true });
          document.addEventListener('click', retry, { once: true });
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadedmetadata', tryPlay, { once: true });
      video.addEventListener('canplay', tryPlay, { once: true });
    }

    /* Pause when out of view to save bandwidth / battery */
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(video);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
